import React from 'react';

const BUSINESS_TYPES = [
  { id: 'plumbing', icon: '🔧', name: 'Plumbing', desc: 'Leaks, installations, emergencies' },
  { id: 'hvac', icon: '❄️', name: 'HVAC', desc: 'Heating, cooling, ventilation' },
  { id: 'electrical', icon: '⚡', name: 'Electrical', desc: 'Wiring, panels, smart home' },
  { id: 'handyman', icon: '🛠️', name: 'Handyman', desc: 'Repairs, assembly, installations' },
  { id: 'cleaning', icon: '🧹', name: 'Cleaning', desc: 'Residential & commercial cleaning' },
  { id: 'landscaping', icon: '🌿', name: 'Landscaping', desc: 'Lawn care, design, maintenance' },
  { id: 'pest_control', icon: '🐛', name: 'Pest Control', desc: 'Inspection, treatment, prevention' },
  { id: 'roofing', icon: '🏠', name: 'Roofing', desc: 'Repair, replacement, inspection' },
  { id: 'painting', icon: '🖌️', name: 'Painting', desc: 'Interior, exterior, commercial' },
  { id: 'pool_service', icon: '🏊', name: 'Pool Service', desc: 'Cleaning, repair, installation' },
  { id: 'moving', icon: '🚚', name: 'Moving', desc: 'Local, long-distance, packing' },
  { id: 'general_contractor', icon: '🔨', name: 'General Contractor', desc: 'Renovation, remodeling, construction' },
  { id: 'mobile_detailing', icon: '🚗', name: 'Mobile Detailing', desc: 'Car wash, polish, ceramic coating' },
  { id: 'home_automation', icon: '🏡', name: 'Home Automation', desc: 'Smart home, security, networking' },
  { id: 'other', icon: '⚙️', name: 'Other', desc: 'Custom setup' },
];

const BusinessTypeStep = ({ selected, onSelect }) => {
  return (
    <div className="space-y-6">
      <div className="text-center">
        <h2 className="text-2xl font-bold text-foreground">What type of business do you run?</h2>
        <p className="text-muted-foreground mt-2 max-w-lg mx-auto">
          We'll set up your CRM with the right tools, templates, and workflows for your industry.
        </p>
      </div>
      <div className="grid grid-cols-2 sm:grid-cols-3 gap-3">
        {BUSINESS_TYPES?.map((type) => {
          const isSelected = selected === type?.id;
          return (
            <button
              key={type?.id}
              onClick={() => onSelect(type?.id)}
              className={`relative flex flex-col items-center text-center p-4 rounded-xl border-2 transition-all duration-200 hover:shadow-md ${
                isSelected
                  ? 'border-primary bg-primary/5 shadow-md'
                  : 'border-border bg-card hover:border-primary/40'
              }`}
            >
              {isSelected && (
                <div className="absolute top-2 right-2 w-5 h-5 bg-primary rounded-full flex items-center justify-center">
                  <svg className="w-3 h-3 text-white" fill="none" viewBox="0 0 24 24" stroke="currentColor">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M5 13l4 4L19 7" />
                  </svg>
                </div>
              )}
              <span className="text-3xl mb-2">{type?.icon}</span>
              <span className={`text-sm font-semibold ${isSelected ? 'text-primary' : 'text-foreground'}`}>
                {type?.name}
              </span>
              <span className="text-xs text-muted-foreground mt-1 leading-tight">{type?.desc}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export { BUSINESS_TYPES };
export default BusinessTypeStep;
